import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
  requestSent: boolean;
  isLoading: boolean;
};

const initialState: InitialState = {
  requestSent: false,
  isLoading: false,
};

const forgotPasswordPageSlice = createSlice({
  name: "forgotPasswordPageSlice",
  initialState,
  reducers: {
    sendRequest: (state, action) => {
      state.isLoading = true;
    },
    setRequestSend: (state) => {
      state.requestSent = true;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default forgotPasswordPageSlice;
